<div class="widget-content">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">Recent Form Responses</h2>
    <item-picker
      [data]="itemPickerValues"
      [selectedValue]="selectedItemPickerValue"
      (select)="itemPickerSelect($event)"
    ></item-picker>
  </div>
  <div *ngIf="loaded">
    <div class="chart-container" *ngIf="chartData">
      <app-chart-canvas [chartData]="chartData" [customColors]="color"></app-chart-canvas>
    </div>

    <div class="no-content" fxLayout="column" fxLayoutAlign="center center" *ngIf="!chartData">
      <p>You have no new responses in the last four months.</p>
      <a
        mat-raised-button
        color="primary"
        href="https://support.lineupteams.com/hc/en-us/articles/360038003234-Creating-an-Lineup-Form"
        >LEARN MORE ABOUT FORMS</a
      >
    </div>
  </div>
  <div *ngIf="!loaded" class="waiting-spinner">
    <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    <p>Loading...</p>
  </div>
</div>
